import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.resource.fields.id'),
  },
  {
    name: 'icon',
    label: i18n('entities.resource.fields.icon'),
    render: exporterRenders.filesOrImages(),
  },
  {
    name: 'name',
    label: i18n('entities.resource.fields.name'),
  },
  {
    name: 'type',
    label: i18n('entities.resource.fields.type'),
  },
  {
    name: 'validatedBy',
    label: i18n('entities.resource.fields.validatedBy'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'rejectedBy',
    label: i18n('entities.resource.fields.rejectedBy'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'closedBy',
    label: i18n('entities.resource.fields.closedBy'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'participants',
    label: i18n('entities.resource.fields.participants'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'administrators',
    label: i18n('entities.resource.fields.administrators'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'viewers',
    label: i18n('entities.resource.fields.viewers'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'parentResource',
    label: i18n('entities.resource.fields.parentResource'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'locationGoogle',
    label: i18n('entities.resource.fields.locationGoogle'),
  },
  {
    name: 'location',
    label: i18n('entities.resource.fields.location'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'keywords',
    label: i18n('entities.resource.fields.keywords'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'formCategory',
    label: i18n('entities.resource.fields.formCategory'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'formTemplate',
    label: i18n('entities.resource.fields.formTemplate'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'relatedTo',
    label: i18n('entities.resource.fields.relatedTo'),
  },
  {
    name: 'status',
    label: i18n('entities.resource.fields.status'),
  },
  {
    name: 'description',
    label: i18n('entities.resource.fields.description'),
  },
  {
    name: 'initDate',
    label: i18n('entities.resource.fields.initDate'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'endDate',
    label: i18n('entities.resource.fields.endDate'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'expirationDate',
    label: i18n('entities.resource.fields.expirationDate'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'relatedLocations',
    label: i18n(
      'entities.resource.fields.relatedLocations',
    ),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'relatedResources',
    label: i18n(
      'entities.resource.fields.relatedResources',
    ),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'relatedAssets',
    label: i18n('entities.resource.fields.relatedAssets'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'owner',
    label: i18n('entities.resource.fields.owner'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'number',
    label: i18n('entities.resource.fields.number'),
  },
  {
    name: 'numberPrefix',
    label: i18n('entities.resource.fields.numberPrefix'),
  },
  {
    name: 'numberSuffix',
    label: i18n('entities.resource.fields.numberSuffix'),
  },
  {
    name: 'directoryPath',
    label: i18n('entities.resource.fields.directoryPath'),
  },
  {
    name: 'actionPlans',
    label: i18n('entities.resource.fields.actionPlans'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'priority',
    label: i18n('entities.resource.fields.priority'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.resource.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.resource.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
